import mnr from "../../img/info/mnr.png";
import "./Information.css";

const MnRPage = () => {
    return (
      <div className="info_container">
        <h1>Maintenance and Rehabilitation (M&R) Emissions </h1>
        <h2>Overview</h2>
        <p>Maintenance and rehabilitation (M&R) activities are essential for preserving and extending the service life of pavements. However, these activities also contribute to greenhouse gas (GHG) emissions due to energy consumption, material production, and construction processes. This page provides an overview of the emissions associated with M&R activities in the pavement’s life cycle.</p>
        <figure className="figure">
            <img src={mnr} alt="MnR" />
            <figcaption>Figure 1 Schematic of M&R treatments for pavements</figcaption>
        </figure>
        <h2>M&R Activities and Emissions</h2>
        <p>M&R activities in pavement management encompass various tasks, each with its associated emissions:</p>
        <ul>
          <li><b>Surface Treatment:</b> Applying surface treatments such as seal coating or micro-surfacing to enhance pavement durability and performance.</li>
          <li><b>Crack Sealing and Filling:</b> Repairing cracks to prevent water infiltration and pavement degradation.</li>
          <li><b>Overlay and Resurfacing:</b> Adding a new layer of asphalt or concrete to restore pavement smoothness and structural integrity.</li>
          <li><b>Milling and Filling:</b> Removing deteriorated pavement layers, filling with new materials and recycling the milled materials for reuse in new construction.</li>
          <li><b>Pothole Patching:</b> Repairing localized pavement distresses, such as potholes or rutting.</li>
          <li><b>Reconstruction:</b> Complete removal and replacement of pavement sections with new materials.</li>
        </ul>
        <h2>Impact on GHG Emissions</h2>
        <p>M&R activities contribute to GHG emissions primarily through energy consumption, material production, transportation, and construction on site:</p>
        <ul>
          <li><b>Material Production (A1):</b> Manufacturing of pavement materials, including asphalt mixes, concrete batches, and aggregates, involves energy-intensive processes and emissions.</li>
          <li><b>Transportation (A2):</b> Transporting materials, equipment, and personnel to and from the construction site adds to emissions, especially over long distances.</li>
          <li><b>Energy Consumption (A3):</b> Operation of construction equipment and machinery during M&R activities requires fuel or electricity, leading to direct emissions.</li>
          <li><b>Construction (A4-A5):</b> Transporting materials and equipment for pavement M&R activities, and operating equipment for site preparation, M&R treatments, compaction, and finishing.</li>
        </ul>
      </div>
    );
  }
  
  export default MnRPage;